import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {MatNativeDateModule} from "@angular/material/core";
import {SettingOptionButtonComponent} from './setting-option-button/setting-option-button.component';
import {WidgetModule} from "../../widget/widget.module";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatMenuModule} from "@angular/material/menu";
import {PipesModule} from "../../providers/pipes/pipes.module";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";



@NgModule({
  declarations: [NavbarComponent, SettingOptionButtonComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        RouterModule,
        TranslateModule,
        MatTooltipModule,
        MatSlideToggleModule,
        MatNativeDateModule,
        WidgetModule,
        PipesModule,
        MatButtonToggleGroup,
        MatButtonToggle,
    ],
    exports: [NavbarComponent, SettingOptionButtonComponent]
})
export class LayoutModule { }
